import { render, staticRenderFns } from "./StoreFrontLinks.vue?vue&type=template&id=4c632905&"
import script from "./StoreFrontLinks.vue?vue&type=script&lang=js&"
export * from "./StoreFrontLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports